/**
 * Small pure formatting helpers, kept separate from `render.ts` so each one
 * has an isolated test that can fail on its own meaning rather than on a
 * rendered page's shape.
 */
import { buildGatewayUrl, type GatewayBase } from '../../../scripts/ipfs-release/schema'

/** Renders an ISO 8601 timestamp as a short, locale-aware date a reader can scan at a glance. */
export const formatPublishedDate = (isoTimestamp: string): string =>
  new Date(isoTimestamp).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })

/** The 7-character short commit out of a release id (`<version>+<7-char commit>`). */
export const shortCommitFromReleaseId = (releaseId: string): string => {
  const commitIndex = releaseId.lastIndexOf('+')
  return commitIndex === -1 ? releaseId : releaseId.slice(commitIndex + 1)
}

/**
 * The full, ready-to-fetch gateway URL for one release, at one gateway host.
 * Delegates to `schema.ts`'s `buildGatewayUrl` — the same function the
 * publish pipeline and the redirect Worker use — so this page's idea of a
 * gateway link can never drift from theirs. The Content ID always lands in
 * the SUBDOMAIN, never the path: see that function's own comment for why.
 */
export const buildGatewayLink = (base: GatewayBase, cid: string): string =>
  buildGatewayUrl(base, cid)
